// Hex/rgba helpers for pastel tinting
export function hexToRgb(hex) {
    if (!hex || typeof hex !== "string") return null;
    const h = hex.replace("#", "").trim();
    if (h.length !== 6 && h.length !== 3) return null;
    const full = h.length === 3 ? h.split("").map(c => c + c).join("") : h;
    const num = parseInt(full, 16);
    if (Number.isNaN(num)) return null;
    return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
}

export function tint(hex, alpha = 0.12) {
    const rgb = hexToRgb(hex);
    if (!rgb) return "transparent";
    return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`;
}

// Slightly darker version of a hex color for accent text/borders
export function shade(hex, amount = 0.35) {
    const rgb = hexToRgb(hex);
    if (!rgb) return hex;
    const f = (v) => Math.max(0, Math.min(255, Math.round(v * (1 - amount))));
    return `rgb(${f(rgb.r)}, ${f(rgb.g)}, ${f(rgb.b)})`;
}
